'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    sizeMaps: {
        'large': 40,
        'middle': 32,
        'small': 24
    },

    sizeMapDefault: 32,

    scrollbarClass: 'v-scrollbar-wrap'
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-easytable/libs/src/settings/settings.js
// module id = 118
// module chunks = 0